// Short Terms & Conditions shown once as a bottom pop-up. Plain data so the Android app can reuse it.
export const TERMS_VERSION = "1";

export const TERMS_TITLE = "Terms & Conditions";

export const TERMS_POINTS = [
  "Check in by 10:00 AM. If you check in after 10:30 AM, your day is marked Absent.",
  "Do not forget to check out when your work ends.",
  "Keep your face clearly in the photo. If your face is not proper, your attendance will not be considered.",
  "Check in only for yourself, from your own phone, and only when you are at work.",
];
